module.exports = __webpack_public_path__ + "img/base_patrimoine_industrie_2.fca85daf.svg";